import {
  formatAddress,
  formatNumber,
  TableColumnProps,
} from '@acme/foundation';
import { Link } from 'react-router-dom';
import { AppRoutes } from '@shared/routes';
import { formatDate } from '@acme/features';
import { OperationItem } from './utilitiesTypes';

export const operationsColumns = (
  type: 'account' | 'crypto'
): TableColumnProps<OperationItem>[] => {
  const columns: TableColumnProps<OperationItem>[] = [
    {
      id: 'applicationNumber',
      title: 'Номер заявки',
      dataIndex: 'application',
      render: (_, row) => (
        <Link
          to={AppRoutes.application.getPath?.(row.application.id) as string}
          className="text-blue-600"
        >
          {row.application.name}
        </Link>
      ),
    },
    {
      id: 'type',
      title: 'Тип операции',
      dataIndex: 'type',
    },
    ...(type === 'account'
      ? [
          {
            id: 'sum',
            title: 'Сумма в рублях',
            sorter: true,
            dataIndex: 'sum',
            render: (_: number, row: OperationItem) =>
              formatNumber(row.sum.value),
          },
        ]
      : [
          {
            id: 'address',
            title: 'Адрес',
            dataIndex: 'address',
            render: (value: string) => (
              <span title={value}>{formatAddress(value)}</span>
            ),
          },
          {
            id: 'sum',
            title: 'Сумма',
            sorter: true,
            dataIndex: 'sum',
            render: (_: number, row: OperationItem) => (
              <div className="flex gap-1">
                {formatNumber(row.sum.value)}
                <span>{row.sum.currency}</span>
              </div>
            ),
          },
        ]),
    {
      id: 'date',
      title: 'Дата',
      sorter: true,
      dataIndex: 'date',
      render: (value) => formatDate(value),
    },
  ];

  if (type === 'crypto') {
    columns.push({
      id: 'pay',
      title: 'Оплата до',
      sorter: true,
      dataIndex: 'pay',
      render: (value: string) => formatDate(value),
    });
  }

  return columns;
};
